// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 516 ? "7cce4023" : chunkId) + "." + {"141":"722142b791f49bf1","324":"e19956bc47671e8d","516":"2cdb9c2b8a72a35b"}[chunkId] + ".js";
};